// forward Geocoding / reverse Geocoding
// Attributions: Along with all the individual attirbution (except Google and Bing)
// the openstreetMaps contribution has to be added, too!! And sometimes even a logo

const mapHostsDataVersion = 2;

const rawMapHostsData = [
  {
    id: 0,
    slug: 'nominatim',
    title: 'Nominatim',
    description: 'Provides free reverse geocoding by searching OpenStreetMap data by name and address. Fair use: max. 1 request per second. Example page: https://nominatim.openstreetmap.org',
    type: 'reverse', // prepare for ol-layerswitcher, which needs "title" and "type" params
    active: false,
    canGeocode: true,
    activatedForGeocoding: false,
    url: {
      type: 'XYZ',
      string: 'https://nominatim.openstreetmap.org/reverse?format=json&lon={lon}&lat={lat}'
    },
    appid: {
      required: false,
      string: 'not required.'
    },
    apikey: {
      required: false,
      string: '',
      url: '',
      text: ''
    },
    layers: [],
    attributions: '<a href="https://nominatim.org/copyright/" target="_blank">&copy; Nominatim</a>',
    createdAt: Date.now(),
    updatedAt: null
  },
  {
    id: 1,
    slug: 'bingmaps',
    title: 'Bing Maps',
    description: 'DEPRECATED. Microsoft is retiring Bing Maps; use Azure Maps instead.',
    deprecated: true,
    deprecatedDate: '2025-06',
    type: 'base', // prepare for ol-layerswitcher, which needs "title" and "type" params
    active: false,
    canGeocode: true,
    activatedForGeocoding: false,
    url: {
      type: 'BingMaps',
      string: 'The Bing Maps URL is handled automatically.'
    },
    appid: {
      required: false,
      string: 'not required'
    },
    apikey: {
      required: true,
      string: '',
      url: 'https://www.bingmapsportal.com/',
      text: 'Get your personal api key here'
    },
    layers: [
      {
        id: 0,
        active: false,
        title: 'RoadOnDemand',
        description: '',
        image: '',
        license: ''
      },
      {
        id: 1,
        active: false,
        title: 'Aerial',
        description: '',
        image: '',
        license: ''
      },
      {
        id: 2,
        active: false,
        title: 'AerialWithLabelsOnDemand',
        description: '',
        image: '',
        license: ''
      },
      {
        id: 3,
        active: false,
        title: 'CanvasDark',
        description: '',
        image: '',
        license: ''
      }
      // {
      //   id: 4,
      //   active: false,
      //   title: 'OrdnanceSurvey',
      //   description: '',
      //   image: '',
      //   license: ''
      // }
    ],
    attributions: '<a href="https://www.bing.com/copyright/" target="_blank">&copy; Microsoft Bing</a>',
    createdAt: Date.now(),
    updatedAt: null
  },
  {
    id: 2,
    slug: 'here',
    title: 'HERE Map Tiles',
    description: 'Uses HERE Raster Tile API v3', // Updated to v3
    type: 'base', // prepare for ol-layerswitcher, which needs "title" and "type" params
    active: false,
    canGeocode: true,
    activatedForGeocoding: false,
    url: {
      type: 'XYZ',
      // Updated to Raster Tile API v3 format (legacy v2.1 deprecated in Q1 2025)
      string: 'https://maps.hereapi.com/v3/base/mc/{z}/{x}/{y}/png?style={scheme}&apiKey={apikey}'
    },
    appid: {
      required: false, // v3 only uses apiKey, not appid
      string: ''
    },
    apikey: {
      required: true,
      string: '',
      url: 'https://developer.here.com/',
      text: 'Get your personal api key here'
    },
    cesiumUrl: 'https://maps.hereapi.com/v3/base/mc/{z}/{x}/{y}/png?style=satellite.day&apiKey={apikey}',
    layers: [
      {
        base: 'base',
        id: 0,
        active: false,
        title: 'Explore Day',
        scheme: 'explore.day', // v3 equivalent of normal.day
        description: '',
        image: '',
        license: '',
        type: 'maptile'
      },
      {
        base: 'base',
        id: 1,
        active: false,
        title: 'Lite Day',
        scheme: 'lite.day', // v3 simplified map style
        description: '',
        image: '',
        license: '',
        type: 'maptile'
      },
      {
        base: 'base',
        id: 2,
        active: false,
        title: 'Topo Day',
        scheme: 'topo.day', // v3 topographic style
        description: '',
        image: '',
        license: '',
        type: 'maptile'
      },
      {
        base: 'aerial',
        id: 3,
        active: false,
        title: 'Satellite Day',
        scheme: 'satellite.day', // v3 satellite imagery
        description: '',
        image: '',
        license: '',
        type: 'maptile'
      },
      {
        base: 'aerial',
        id: 4,
        active: false,
        title: 'Explore Satellite Day',
        scheme: 'explore.satellite.day', // v3 satellite with labels
        description: '',
        image: '',
        license: '',
        type: 'maptile'
      },
      {
        base: 'base',
        id: 5,
        active: false,
        title: 'Explore Night',
        scheme: 'explore.night', // v3 night mode
        description: '',
        image: '',
        license: '',
        type: 'maptile'
      }
    ],
    attributions: '<a href="https://www.here.com/copyright" target="_blank">&copy; HERE Map Tiles</a>',
    createdAt: Date.now(),
    updatedAt: null
  },
  {
    id: 21,
    slug: 'cesium-ion',
    title: 'Cesium ion',
    description: 'Stores your personal Cesium access token for the optional 3D viewer and future Cesium-backed terrain features.',
    type: 'service',
    serviceOnly: true,
    serviceCategory: 'three-d',
    active: false,
    canGeocode: false,
    activatedForGeocoding: false,
    url: {
      type: 'SDK',
      string: 'CesiumJS SDK with optional Cesium ion-backed services.'
    },
    appid: {
      required: false,
      string: 'not required'
    },
    apikey: {
      required: false,
      optional: true,
      string: '',
      url: 'https://ion.cesium.com/tokens',
      text: 'Manage your Cesium access tokens',
      label: 'Your Personal Cesium Access Token',
      placeholder: 'Paste your Cesium access token to enable Cesium ion-backed services'
    },
    layers: [],
    attributions: '<a href="https://cesium.com/platform/cesium-ion/" target="_blank">&copy; Cesium ion</a>',
    createdAt: Date.now(),
    updatedAt: null
  },
  {
    id: 3,
    slug: 'mapbox',
    title: 'Mapbox',
    description: 'High-quality map tiles with multiple styles',
    type: 'base',
    active: false,
    canGeocode: true,
    activatedForGeocoding: false,
    url: {
      type: 'XYZ',
      string: 'https://api.mapbox.com/styles/v1/{styleId}/tiles/256/{z}/{x}/{y}?access_token={apikey}'
    },
    appid: {
      required: false,
      string: 'not required'
    },
    apikey: {
      required: true,
      string: '',
      url: 'https://account.mapbox.com/access-tokens/',
      text: 'Get your access token here'
    },
    cesiumUrl: 'https://api.mapbox.com/styles/v1/mapbox/satellite-v9/tiles/{z}/{x}/{y}?access_token={apikey}',
    layers: [
      { title: 'Streets', styleId: 'mapbox/streets-v12', active: false },
      { title: 'Outdoors', styleId: 'mapbox/outdoors-v12', active: false },
      { title: 'Light', styleId: 'mapbox/light-v11', active: false },
      { title: 'Dark', styleId: 'mapbox/dark-v11', active: false },
      { title: 'Satellite', styleId: 'mapbox/satellite-v9', active: false },
      { title: 'Satellite Streets', styleId: 'mapbox/satellite-streets-v12', active: false }
    ],
    attributions: '© <a href="https://www.mapbox.com/about/maps/" target="_blank">Mapbox</a>',
    createdAt: Date.now(),
    updatedAt: null
  },
  {
    id: 4,
    slug: 'maptiler',
    title: 'MapTiler',
    description: 'High-quality map tiles with multiple styles. Free tier: 300k sessions/month.',
    type: 'base', // prepare for ol-layerswitcher, which needs "title" and "type" params
    active: false,
    canGeocode: true,
    activatedForGeocoding: false,
    url: {
      type: 'XYZ',
      string: 'https://api.maptiler.com/maps/{mapId}/256/{z}/{x}/{y}@2x.png?key={apikey}'
    },
    appid: {
      required: false,
      string: 'not required'
    },
    apikey: {
      required: true,
      string: '',
      text: 'Get your personal api key here',
      url: 'https://www.maptiler.com/cloud/'
    },
    cesiumUrl: 'https://api.maptiler.com/tiles/satellite-v2/{z}/{x}/{y}.jpg?key={apikey}',
    layers: [
      { title: 'Aquarelle', mapId: 'aquarelle', active: false },
      { title: 'Backdrop', mapId: 'backdrop', active: false },
      { title: 'Basic', mapId: 'basic-v2', active: false },
      { title: 'Bright', mapId: 'bright-v2', active: false },
      { title: 'Dataviz', mapId: 'dataviz', active: false },
      { title: 'Dataviz Dark', mapId: 'dataviz-dark', active: false },
      { title: 'Dataviz Light', mapId: 'dataviz-light', active: false },
      { title: 'Hybrid', mapId: 'hybrid', active: false },
      { title: 'Landscape', mapId: 'landscape', active: false },
      { title: 'Ocean', mapId: 'ocean', active: false },
      { title: 'OpenStreetMap', mapId: 'openstreetmap', active: false },
      { title: 'Outdoor', mapId: 'outdoor-v2', active: false },
      { title: 'Pastel', mapId: 'pastel', active: false },
      { title: 'Satellite', mapId: 'satellite-v2', tileUrl: 'https://api.maptiler.com/tiles/satellite-v2/{z}/{x}/{y}.jpg?key={apikey}', active: false },
      { title: 'Streets', mapId: 'streets-v2', active: false },
      { title: 'Streets Dark', mapId: 'streets-v2-dark', active: false },
      { title: 'Streets Light', mapId: 'streets-v2-light', active: false },
      { title: 'Topo', mapId: 'topo-v2', active: false },
      { title: 'Topographique', mapId: 'topographique', active: false },
      { title: 'Winter', mapId: 'winter-v2', active: false }
    ],
    attributions: '<a href="https://www.maptiler.com/copyright/" target="_blank">&copy; MapTiler</a>',
    createdAt: Date.now(),
    updatedAt: null
  },
  {
    id: 5,
    slug: 'carto',
    title: 'Carto',
    description: 'Free basemaps with OpenStreetMap data',
    type: 'base',
    active: false,
    canGeocode: false,
    activatedForGeocoding: false,
    url: {
      type: 'XYZ',
      string: 'https://{a-d}.basemaps.cartocdn.com/{style}/{z}/{x}/{y}.png'
    },
    appid: {
      required: false,
      string: 'not required'
    },
    apikey: {
      required: false,
      string: ''
    },
    layers: [
      { title: 'Positron', style: 'light_all', active: false },
      { title: 'Positron (No Labels)', style: 'light_nolabels', active: false },
      { title: 'Dark Matter', style: 'dark_all', active: false },
      { title: 'Dark Matter (No Labels)', style: 'dark_nolabels', active: false },
      { title: 'Voyager', style: 'rastertiles/voyager', active: false },
      { title: 'Voyager (No Labels)', style: 'rastertiles/voyager_nolabels', active: false }
    ],
    attributions: '© <a href="https://carto.com/attributions" target="_blank">CARTO</a>',
    createdAt: Date.now(),
    updatedAt: null
  },
  {
    id: 6,
    slug: 'stamen',
    title: 'Stamen (Deprecated)',
    description: 'Deprecated. The legacy Stamen tile service was retired (Oct 2023). Use "Stadia Maps" for Stamen styles (e.g. stamen_toner, stamen_terrain, stamen_watercolor).',
    deprecated: true,
    deprecatedDate: '2023-10',
    type: 'base', // prepare for ol-layerswitcher, which needs "title" and "type" params
    active: false,
    canGeocode: false,
    activatedForGeocoding: false,
    url: {
      type: 'XYZ',
      string: 'Managed by OpenLayers StadiaMaps source'
    },
    appid: {
      required: false,
      string: 'not required'
    },
    apikey: {
      required: false,
      optional: true,
      string: '',
      text: 'More info',
      url: 'https://docs.stadiamaps.com/guides/migrating-from-stamen-map-tiles/'
    },
    layers: [
      {
        id: 0,
        active: false,
        title: 'Terrain',
        layer: 'stamen_terrain',
        description: 'Terrain with labels',
        image: '',
        license: 'Map tiles by <a href="http://stamen.com" target="_blank">Stamen Design</a>, under <a href="http://creativecommons.org/licenses/by/3.0">CC BY 3.0</a>. Data by <a href="http://openstreetmap.org" target="_blank">OpenStreetMap</a>, under <a href="http://www.openstreetmap.org/copyright" target="_blank">ODbL</a>.'
      },
      {
        id: 1,
        active: false,
        title: 'Terrain (Background)',
        layer: 'stamen_terrain_background',
        description: 'Terrain background only (no labels)',
        image: '',
        license: 'Map tiles by <a href="http://stamen.com" target="_blank">Stamen Design</a>, under <a href="http://creativecommons.org/licenses/by/3.0">CC BY 3.0</a>. Data by <a href="http://openstreetmap.org" target="_blank">OpenStreetMap</a>, under <a href="http://www.openstreetmap.org/copyright" target="_blank">ODbL</a>.'
      },
      {
        id: 2,
        active: false,
        title: 'Terrain (Labels overlay)',
        layer: 'stamen_terrain_labels',
        description: 'Labels only (transparent overlay; combine with a background/basemap)',
        image: '',
        license: 'Map tiles by <a href="http://stamen.com" target="_blank">Stamen Design</a>, under <a href="http://creativecommons.org/licenses/by/3.0">CC BY 3.0</a>. Data by <a href="http://openstreetmap.org" target="_blank">OpenStreetMap</a>, under <a href="http://www.openstreetmap.org/copyright" target="_blank">ODbL</a>.'
      },
      {
        id: 3,
        active: false,
        title: 'Terrain (Lines overlay)',
        layer: 'stamen_terrain_lines',
        description: 'Lines only (transparent overlay; combine with a background/basemap)',
        image: '',
        license: 'Map tiles by <a href="http://stamen.com" target="_blank">Stamen Design</a>, under <a href="http://creativecommons.org/licenses/by/3.0">CC BY 3.0</a>. Data by <a href="http://openstreetmap.org" target="_blank">OpenStreetMap</a>, under <a href="http://www.openstreetmap.org/copyright" target="_blank">ODbL</a>.'
      },
      {
        id: 4,
        active: false,
        title: 'Toner',
        layer: 'stamen_toner',
        description: 'High-contrast B+W map',
        image: '',
        license: 'Map tiles by <a href="http://stamen.com" target="_blank">Stamen Design</a>, under <a href="http://creativecommons.org/licenses/by/3.0">CC BY 3.0</a>. Data by <a href="http://openstreetmap.org" target="_blank">OpenStreetMap</a>, under <a href="http://www.openstreetmap.org/copyright" target="_blank">ODbL</a>.'
      },
      {
        id: 5,
        active: false,
        title: 'Toner (Background)',
        layer: 'stamen_toner_background',
        description: 'Toner background only (no labels)',
        image: '',
        license: 'Map tiles by <a href="http://stamen.com" target="_blank">Stamen Design</a>, under <a href="http://creativecommons.org/licenses/by/3.0">CC BY 3.0</a>. Data by <a href="http://openstreetmap.org" target="_blank">OpenStreetMap</a>, under <a href="http://www.openstreetmap.org/copyright" target="_blank">ODbL</a>.'
      },
      {
        id: 6,
        active: false,
        title: 'Toner (Labels overlay)',
        layer: 'stamen_toner_labels',
        description: 'Labels only (transparent overlay; combine with a background/basemap)',
        image: '',
        license: 'Map tiles by <a href="http://stamen.com" target="_blank">Stamen Design</a>, under <a href="http://creativecommons.org/licenses/by/3.0">CC BY 3.0</a>. Data by <a href="http://openstreetmap.org" target="_blank">OpenStreetMap</a>, under <a href="http://www.openstreetmap.org/copyright" target="_blank">ODbL</a>.'
      },
      {
        id: 7,
        active: false,
        title: 'Toner (Lines overlay)',
        layer: 'stamen_toner_lines',
        description: 'Lines only (transparent overlay; combine with a background/basemap)',
        image: '',
        license: 'Map tiles by <a href="http://stamen.com" target="_blank">Stamen Design</a>, under <a href="http://creativecommons.org/licenses/by/3.0">CC BY 3.0</a>. Data by <a href="http://openstreetmap.org" target="_blank">OpenStreetMap</a>, under <a href="http://www.openstreetmap.org/copyright" target="_blank">ODbL</a>.'
      },
      {
        id: 8,
        active: false,
        title: 'Toner Lite',
        layer: 'stamen_toner_lite',
        description: 'Lighter version of Toner',
        image: '',
        license: 'Map tiles by <a href="http://stamen.com" target="_blank">Stamen Design</a>, under <a href="http://creativecommons.org/licenses/by/3.0">CC BY 3.0</a>. Data by <a href="http://openstreetmap.org" target="_blank">OpenStreetMap</a>, under <a href="http://www.openstreetmap.org/copyright" target="_blank">ODbL</a>.'
      },
      {
        id: 9,
        active: false,
        title: 'Watercolor',
        layer: 'stamen_watercolor',
        description: 'Artistic watercolor style',
        image: '',
        license: 'Map tiles by <a href="http://stamen.com" target="_blank">Stamen Design</a>, under <a href="http://creativecommons.org/licenses/by/3.0" target="_blank">CC BY 3.0</a>.<br>Data by <a href="http://openstreetmap.org" target="_blank">OpenStreetMap</a>, under <a href="http://creativecommons.org/licenses/by-sa/3.0" target="_blank">CC BY SA</a>.'
      }
    ],
    attributions: '<a href="https://stadiamaps.com/" target="_blank">&copy; Stadia Maps</a> <a href="http://stamen.com" target="_blank">&copy; Stamen Design</a>',
    createdAt: Date.now(),
    updatedAt: null
  },
  {
    /**
     * @see https://openlayers.org/en/main/examples/wmts-hidpi.html
     */
    id: 7,
    slug: 'basemap',
    title: 'basemap',
    description: '',
    type: 'base', // prepare for ol-layerswitcher, which needs "title" and "type" params
    active: false,
    canGeocode: true,
    activatedForGeocoding: false,
    url: {
      type: 'XYZ',
      url: 'https://{s}.basemaps.at/{style}/{z}/{x}/{y}{scale}.png' // @src https://github.com/CartoDB/basemap-styles
    },
    appid: {
      required: false,
      string: 'not required'
    },
    apikey: {
      required: true,
      string: '',
      url: 'http://www.basemap.at/',
      text: 'More info'
    },
    layers: [
      {
        id: 0,
        active: false,
        title: 'Standard',
        description: '',
        image: '',
        license: ''
      },
      {
        id: 1,
        active: false,
        title: 'HiDPI',
        description: '',
        image: '',
        license: ''
      },
      {
        id: 2,
        active: false,
        title: 'Grau',
        description: '',
        image: '',
        license: ''
      },
      {
        id: 3,
        active: false,
        title: 'Overlay',
        description: '',
        image: '',
        license: ''
      },
      {
        id: 4,
        active: false,
        title: 'Vector',
        description: '',
        image: '',
        license: ''
      }
    ],
    attributions: 'Grundkarte <a href="https://www.basemap.at" target="_blank">basemap.at</a>',
    createdAt: Date.now(),
    updatedAt: null
  },
  {
    id: 8,
    slug: 'thunderforest',
    title: 'Thunderforest',
    description: '',
    type: 'base', // prepare for ol-layerswitcher, which needs "title" and "type" params
    active: false,
    canGeocode: false,
    activatedForGeocoding: false,
    url: {
      type: 'XYZ',
      string: 'https://{a-c}.tile.thunderforest.com/{type}/{z}/{x}/{y}.png?apikey={apikey}'
    },
    appid: {
      required: false,
      string: 'not required'
    },
    apikey: {
      required: true,
      string: '',
      url: 'https://www.thunderforest.com/',
      text: 'get your personal api key here'
    },
    layers: [
      {
        id: 0,
        active: false,
        title: 'OpenCycleMaps',
        type: 'cycle',
        description: '',
        image: '',
        license: ''
      },
      {
        id: 1,
        active: false,
        title: 'Transport',
        type: 'transport',
        description: '',
        image: '',
        license: ''
      },
      {
        id: 2,
        active: false,
        title: 'Landscape',
        type: 'landscape',
        description: '',
        image: '',
        license: ''
      },
      {
        id: 3,
        active: false,
        title: 'Outdoors',
        type: 'outdoors',
        description: '',
        image: '',
        license: ''
      },
      {
        id: 4,
        active: false,
        title: 'Atlas',
        type: 'atlas',
        description: '',
        image: '',
        license: ''
      },
      {
        id: 5,
        active: false,
        title: 'Spinal Map',
        type: 'spinal-map',
        description: '',
        image: '',
        license: ''
      }
    ],
    attributions: 'Maps © <a href="https://www.thunderforest.com/ target="_blank">Thunderforest</a><br>',
    createdAt: Date.now(),
    updatedAt: null
  },
  {
    id: 9,
    slug: 'azure',
    title: 'Azure Maps',
    description: 'Microsoft Azure Maps - Cloud-based mapping service with global coverage',
    type: 'base',
    active: false,
    canGeocode: true,
    activatedForGeocoding: false,
    url: {
      type: 'XYZ',
      string: 'https://atlas.microsoft.com/map/tile?api-version=2024-04-01&tilesetId={tilesetId}&zoom={z}&x={x}&y={y}&tileSize=256&subscription-key={apikey}'
    },
    appid: {
      required: false,
      string: ''
    },
    apikey: {
      required: true,
      string: '',
      url: 'https://portal.azure.com/',
      text: 'Get your Azure Maps primary key from Azure Portal'
    },
    cesiumUrl: 'https://atlas.microsoft.com/map/tile?api-version=2024-04-01&tilesetId=microsoft.imagery&zoom={z}&x={x}&y={y}&subscription-key={apikey}',
    layers: [
      {
        id: 0,
        active: false,
        title: 'Road',
        tilesetId: 'microsoft.base.road',
        description: 'Main road map style',
        image: '',
        license: ''
      },
      {
        id: 1,
        active: false,
        title: 'Dark Grey',
        tilesetId: 'microsoft.base.darkgrey',
        description: 'Dark theme map style',
        image: '',
        license: ''
      },
      {
        id: 2,
        active: false,
        title: 'Satellite',
        tilesetId: 'microsoft.imagery',
        description: 'Aerial imagery (requires S1/G2 SKU)',
        image: '',
        license: ''
      },
      {
        id: 3,
        active: false,
        title: 'Hybrid Road',
        tilesetId: 'microsoft.base.hybrid.road',
        description: 'Road labels over imagery',
        image: '',
        license: ''
      }
    ],
    attributions: '© <a href="https://azure.microsoft.com/en-us/products/azure-maps/" target="_blank">TomTom, Microsoft</a>',
    createdAt: Date.now(),
    updatedAt: null
  },
  {
    id: 10,
    slug: 'stadiamaps',
    title: 'Stadia Maps',
    description: 'Raster tiles from Stadia Maps (includes Stadia styles and Stadia×Stamen styles). Uses OpenLayers built-in StadiaMaps source (OpenLayers v8+).',
    type: 'base',
    active: false,
    canGeocode: false,
    activatedForGeocoding: false,
    url: {
      type: 'StadiaMaps',
      string: 'Managed by OpenLayers StadiaMaps source'
    },
    appid: {
      required: false,
      string: 'not required'
    },
    apikey: {
      required: false,
      optional: true,
      string: '',
      text: 'Authentication info',
      url: 'https://docs.stadiamaps.com/authentication/'
    },
    layers: [
      {
        id: 0,
        active: false,
        title: 'Alidade Smooth',
        layer: 'alidade_smooth',
        description: 'Light, clean basemap style',
        image: '',
        license: ''
      },
      {
        id: 1,
        active: false,
        title: 'Alidade Smooth Dark',
        layer: 'alidade_smooth_dark',
        description: 'Dark basemap style',
        image: '',
        license: ''
      },
      {
        id: 2,
        active: false,
        title: 'Outdoors',
        layer: 'outdoors',
        description: 'Outdoor-focused basemap style',
        image: '',
        license: ''
      },
      {
        id: 3,
        active: false,
        title: 'OSM Bright',
        layer: 'osm_bright',
        description: 'OpenStreetMap-based bright basemap style',
        image: '',
        license: ''
      },
      {
        id: 4,
        active: false,
        title: 'Stamen Toner',
        layer: 'stamen_toner',
        description: 'Stadia × Stamen — high-contrast B+W basemap',
        image: '',
        license: ''
      },
      {
        id: 5,
        active: false,
        title: 'Stamen Toner Lite',
        layer: 'stamen_toner_lite',
        description: 'Stadia × Stamen — lighter version of Toner',
        image: '',
        license: ''
      },
      {
        id: 6,
        active: false,
        title: 'Stamen Terrain',
        layer: 'stamen_terrain',
        description: 'Stadia × Stamen — terrain basemap with labels',
        image: '',
        license: ''
      },
      {
        id: 7,
        active: false,
        title: 'Stamen Watercolor',
        layer: 'stamen_watercolor',
        description: 'Stadia × Stamen — artistic watercolor style (no retina)',
        image: '',
        license: ''
      }
    ],
    attributions: '<a href="https://stadiamaps.com/" target="_blank">&copy; Stadia Maps</a>',
    createdAt: Date.now(),
    updatedAt: null
  },
  {
    id: 11,
    slug: 'openmaptiles',
    title: 'OpenMapTiles',
    description: 'OpenMapTiles via TileServer GL (raster tiles endpoint). No API key required. Default URL points to a public TileServer GL demo.',
    type: 'base',
    active: false,
    canGeocode: false,
    activatedForGeocoding: false,
    url: {
      type: 'XYZ',
      // TileServer GL rendered tiles endpoint:
      // /styles/{id}[/{tileSize}]/{z}/{x}/{y}[@2x].{format}
      string: 'https://tile.openstreetmap.jp/styles/{style}/256/{z}/{x}/{y}{scale}.png'
    },
    appid: {
      required: false,
      string: 'not required'
    },
    apikey: {
      required: false,
      string: '',
      text: 'TileServer GL docs',
      url: 'https://openmaptiles.org/docs/host/tileserver-gl/'
    },
    layers: [
      {
        id: 0,
        active: false,
        title: 'OSM OpenMapTiles',
        style: 'openmaptiles',
        description: 'Default OpenMapTiles style (style id may differ by server configuration).',
        image: '',
        license: ''
      },
      {
        id: 1,
        active: false,
        title: 'OSM Bright',
        style: 'osm-bright',
        description: 'OSM Bright (available on the default demo server).',
        image: '',
        license: ''
      },
      {
        id: 2,
        active: false,
        title: 'OSM Bright (EN)',
        style: 'osm-bright-en',
        description: 'OSM Bright (English labels) on the default demo server.',
        image: '',
        license: ''
      },
      {
        id: 3,
        active: false,
        title: 'OSM Bright (JA)',
        style: 'osm-bright-ja',
        description: 'OSM Bright (Japanese labels) on the default demo server.',
        image: '',
        license: ''
      },
      {
        id: 4,
        active: false,
        title: 'MapTiler Basic (EN)',
        style: 'maptiler-basic-en',
        description: 'MapTiler Basic (English) on the default demo server.',
        image: '',
        license: ''
      },
      {
        id: 5,
        active: false,
        title: 'MapTiler Basic (JA)',
        style: 'maptiler-basic-ja',
        description: 'MapTiler Basic (Japanese) on the default demo server.',
        image: '',
        license: ''
      },
      {
        id: 6,
        active: false,
        title: 'Toner (EN)',
        style: 'maptiler-toner-en',
        description: 'Toner (English) on the default demo server.',
        image: '',
        license: ''
      },
      {
        id: 7,
        active: false,
        title: 'Toner (JA)',
        style: 'maptiler-toner-ja',
        description: 'Toner (Japanese) on the default demo server.',
        image: '',
        license: ''
      }
    ],
    attributions: '<a href="https://openmaptiles.org/" target="_blank">&copy; OpenMapTiles</a>',
    createdAt: Date.now(),
    updatedAt: null
  },
  {
    id: 12,
    slug: 'arcgis',
    title: 'ArcGIS / Esri',
    description: 'Esri ArcGIS Location Platform — satellite imagery, topographic and street maps with geocoding, routing, and elevation services. Free tier: 2,000,000 basemap tiles/month.',
    type: 'base',
    active: false,
    canGeocode: true,
    activatedForGeocoding: false,
    url: {
      type: 'XYZ',
      // ArcGIS Static Basemap Tiles API — note: {z}/{y}/{x} order (Y before X!)
      string: 'https://static-map-tiles-api.arcgis.com/arcgis/rest/services/static-basemap-tiles-service/v1/arcgis/{style}/static/tile/{z}/{y}/{x}?token={apikey}'
    },
    appid: {
      required: false,
      string: ''
    },
    apikey: {
      required: true,
      string: '',
      url: 'https://location.arcgis.com/',
      text: 'Get your API key from the ArcGIS Location Platform (free developer account)'
    },
    cesiumUrl: 'https://ibasemaps-api.arcgis.com/arcgis/rest/services/World_Imagery/MapServer/tile/{z}/{y}/{x}?token={apikey}',
    layers: [
      {
        id: 0,
        active: false,
        title: 'Imagery',
        style: 'imagery',
        description: 'High-resolution satellite and aerial imagery (World Imagery)',
        image: '',
        license: ''
      },
      {
        id: 1,
        active: false,
        title: 'Streets',
        style: 'streets',
        description: 'Standard road map with labels',
        image: '',
        license: ''
      },
      {
        id: 2,
        active: false,
        title: 'Navigation',
        style: 'navigation',
        description: 'Navigation-optimized map',
        image: '',
        license: ''
      },
      {
        id: 3,
        active: false,
        title: 'Topographic',
        style: 'topographic',
        description: 'Topographic contour map',
        image: '',
        license: ''
      },
      {
        id: 4,
        active: false,
        title: 'Dark Gray',
        style: 'dark-gray',
        description: 'Dark gray canvas basemap',
        image: '',
        license: ''
      },
      {
        id: 5,
        active: false,
        title: 'Light Gray',
        style: 'light-gray',
        description: 'Light gray canvas basemap',
        image: '',
        license: ''
      },
      {
        id: 6,
        active: false,
        title: 'Oceans',
        style: 'oceans',
        description: 'Ocean-focused basemap with bathymetry',
        image: '',
        license: ''
      }
    ],
    attributions: '© <a href="https://www.esri.com/" target="_blank">Esri</a>, Sources: Esri, Maxar, Earthstar Geographics',
    createdAt: Date.now(),
    updatedAt: null
  }
  // {
  //   id: 9,
  //   slug: 'openstreetmap',
  //   title: 'OpenStreetMap',
  //   description: '',
  //   type: 'base', // prepare for ol-layerswitcher, which needs "title" and "type" params
  //   active: false,
  //   canGeocode: false,
  //   activatedForGeocoding: false,
  //   url: {
  //     type: 'XYZ',
  //     string: ''
  //   },
  //   appid: {
  //     required: false,
  //     string: 'not required'
  //   },
  //   apikey: {
  //     required: false,
  //     string: '',
  //     url: 'https://www.openstreetmaps.org/',
  //     text: 'more info'
  //   },
  //   layers: [],
  //   attributions: 'Maps © <a href="https://www.openstreetmaps.org/" target="_blank">Thunderforest</a><br>',
  //   createdAt: Date.now(),
  //   updatedAt: null
  // }
];

const geocodeCapabilityPresetsBySlug = {
  nominatim: {
    supportsForwardGeocode: true,
    supportsReverseGeocode: true,
    supportsRadiusBias: true,
    requiresApiKey: false,
    isEnabled: true
  },
  here: {
    supportsForwardGeocode: true,
    supportsReverseGeocode: true,
    supportsRadiusBias: true,
    requiresApiKey: true,
    isEnabled: false
  },
  mapbox: {
    supportsForwardGeocode: true,
    supportsReverseGeocode: true,
    supportsRadiusBias: true,
    requiresApiKey: true,
    isEnabled: false
  },
  azure: {
    supportsForwardGeocode: true,
    supportsReverseGeocode: true,
    supportsRadiusBias: true,
    requiresApiKey: true,
    isEnabled: false
  },
  arcgis: {
    supportsForwardGeocode: true,
    supportsReverseGeocode: true,
    supportsRadiusBias: true,
    requiresApiKey: true,
    isEnabled: false
  }
};

function applyGeocodeCapabilities (host) {
  const preset = geocodeCapabilityPresetsBySlug[host?.slug] || {};
  const geosearchPolicyExplicit = Boolean(host?.geosearchPolicyExplicit);

  const resolveIsEnabled = () => {
    if (typeof host?.isEnabled === 'boolean') {
      // Legacy DB states can contain a derived false value for Nominatim.
      // Keep Nominatim enabled by default unless user explicitly changed policy.
      if (host?.slug === 'nominatim' && host.isEnabled === false && !geosearchPolicyExplicit) {
        return true;
      }
      return host.isEnabled;
    }

    if (host?.slug === 'nominatim') {
      return true;
    }

    if (typeof host?.activatedForGeocoding === 'boolean') {
      return host.activatedForGeocoding;
    }

    if (typeof host?.active === 'boolean') {
      return host.active;
    }

    if (typeof preset.isEnabled === 'boolean') {
      return preset.isEnabled;
    }

    return false;
  };

  return {
    ...host,
    supportsForwardGeocode: host?.supportsForwardGeocode
      ?? preset.supportsForwardGeocode
      ?? Boolean(host?.canGeocode),
    supportsReverseGeocode: host?.supportsReverseGeocode
      ?? preset.supportsReverseGeocode
      ?? Boolean(host?.canGeocode),
    supportsRadiusBias: host?.supportsRadiusBias
      ?? preset.supportsRadiusBias
      ?? false,
    requiresApiKey: host?.requiresApiKey
      ?? preset.requiresApiKey
      ?? Boolean(host?.apikey?.required),
    isEnabled: resolveIsEnabled(),
    geosearchPolicyExplicit
  };
}

const mapHostsData = rawMapHostsData.map((host) => applyGeocodeCapabilities(host));

export { mapHostsData, mapHostsDataVersion };
